import { render, staticRenderFns } from "./StockMove.vue?vue&type=template&id=1e67c3e8&scoped=true"
import script from "./StockMove.vue?vue&type=script&lang=js"
export * from "./StockMove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e67c3e8",
  null
  
)

export default component.exports